module.exports = __webpack_public_path__ + "img/error404.728215ed.png";